/** Espelha em TS a lógica de `backend/src/utils/janelaHorario.js`, para uso no front-end. */
export interface JanelaHorarioPerfil {
  horarioInicio?: string;
  horarioFim?: string;
  diasSemana?: string[];
}

function minutosDoDia(horaTexto: string | undefined): number | null {
  const match = /^(\d{1,2}):(\d{2})$/.exec(String(horaTexto || "").trim());
  if (!match) return null;
  const h = Number(match[1]);
  const m = Number(match[2]);
  if (!Number.isFinite(h) || !Number.isFinite(m) || h > 23 || m > 59) return null;
  return h * 60 + m;
}

export function dentroDaJanela(perfil: JanelaHorarioPerfil, now: Date = new Date()): boolean {
  const horarioInicio = String(perfil.horarioInicio ?? "").trim();
  const horarioFim = String(perfil.horarioFim ?? "").trim();
  const diasSemana = Array.isArray(perfil.diasSemana) ? perfil.diasSemana.map(String) : [];

  if (diasSemana.length && !diasSemana.includes(String(now.getDay()))) {
    return false;
  }

  if (!horarioInicio && !horarioFim) return true;

  const inicioMin = minutosDoDia(horarioInicio);
  const fimMin = minutosDoDia(horarioFim);
  if (inicioMin === null || fimMin === null) return true;

  const atualMin = now.getHours() * 60 + now.getMinutes();

  if (inicioMin <= fimMin) {
    return atualMin >= inicioMin && atualMin <= fimMin;
  }
  return atualMin >= inicioMin || atualMin <= fimMin;
}

/**
 * Milissegundos até o próximo instante em que a janela deixa de permitir acesso,
 * partindo de um momento em que o acesso está liberado. `null` quando não há
 * restrição de horário (não fecha nunca) ou quando já está fora da janela.
 */
export function msAteFecharJanela(perfil: JanelaHorarioPerfil, now: Date = new Date()): number | null {
  if (!perfil.horarioInicio && !perfil.horarioFim) return null;
  if (!dentroDaJanela(perfil, now)) return null;

  const fimMin = minutosDoDia(perfil.horarioFim);
  if (fimMin === null) return null;

  const fechamento = new Date(now);
  fechamento.setHours(Math.floor(fimMin / 60), fimMin % 60, 0, 0);
  if (fechamento.getTime() <= now.getTime()) {
    fechamento.setDate(fechamento.getDate() + 1);
  }
  return fechamento.getTime() - now.getTime();
}
